import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchSocials } from "../lib/api";
import { SocialIcons } from "../components/Socials";

export default function AboutPage() {
    const { t } = useTranslation();
    const [socials, setSocials] = useState(null);
    useEffect(() => { fetchSocials().then(setSocials); }, []);

    const BULLETS = [
        { id: "snow", emoji: "❄️", text: t("about.b1") },
        { id: "world", emoji: "🌐", text: t("about.b2") },
        { id: "ice", emoji: "🧊", text: t("about.b3") },
        { id: "rocket", emoji: "🚀", text: t("about.b4") },
    ];

    return (
        <div data-testid="about-page" className="max-w-5xl mx-auto px-4 md:px-8 py-16">
            <div className="text-xs uppercase tracking-[0.3em] text-frost mb-4">{t("about.kicker")}</div>
            <h1 className="font-serif text-5xl md:text-6xl tracking-tight leading-[0.95]">
                {t("about.title_1")}<br />
                {t("about.title_2")} <span className="italic text-frost">{t("about.title_3")}</span>{" "}
                {t("about.title_4")} <span className="italic">{t("about.title_5")}</span>
            </h1>

            <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-7 space-y-6 text-base font-mono text-slate-300 leading-relaxed">
                    <p>{t("about.p1")}</p>
                    <p>{t("about.p2")}</p>
                    <p className="font-serif text-2xl text-white not-italic">
                        {t("about.not_buying_land")}<br />
                        {t("about.powerful_asset_1")}{" "}
                        <span className="italic text-frost">{t("about.powerful_asset_2")}</span>
                        {t("about.powerful_asset_3")}
                    </p>
                    <p className="text-xs uppercase tracking-[0.2em] text-slate-500 pt-4">
                        {t("about.token_is")}
                    </p>
                    <ul className="space-y-3 not-prose">
                        {BULLETS.map((b) => (
                            <li key={b.id} className="flex items-start gap-3 border-l-2 border-frost/40 pl-4 py-1">
                                <span className="text-xl">{b.emoji}</span>
                                <span className="text-slate-200">{b.text}</span>
                            </li>
                        ))}
                    </ul>
                    <p className="pt-4 italic text-slate-400">{t("about.outro")}</p>
                </div>

                <aside className="md:col-span-5 space-y-8">
                    <div className="bg-slate-900/40 border border-white/10 p-6">
                        <div className="text-xs uppercase tracking-[0.3em] text-gold mb-4">
                            {t("about.network")}
                        </div>
                        <div className="space-y-3 text-sm font-mono">
                            <Stat k={t("about.continent")} v="Antarctica" />
                            <Stat k={t("about.supply")} v="14,200" />
                            <Stat k={t("about.parcel_size")} v="~1,000 km²" />
                            <Stat k={t("hero.stats.top")} v={`13 · ${t("hero.stats.auction")}`} />
                            <Stat k="Chain" v="Polygon" />
                            <Stat k="Currency" v="USDC" />
                            <Stat k="Standard" v="ERC-721" />
                        </div>
                    </div>

                    <div className="bg-slate-900/40 border border-white/10 p-6">
                        <div className="text-xs uppercase tracking-[0.3em] text-frost mb-4">
                            {t("about.follow_title")}
                        </div>
                        <SocialIcons socials={socials} size="lg" />
                        <p className="text-[11px] font-mono text-slate-500 mt-4 leading-relaxed">
                            {t("about.follow_text")}
                        </p>
                    </div>
                </aside>
            </div>
        </div>
    );
}

function Stat({ k, v }) {
    return (
        <div className="flex justify-between border-b border-white/5 pb-2">
            <span className="text-slate-500 uppercase tracking-[0.2em] text-[10px]">{k}</span>
            <span className="text-white">{v}</span>
        </div>
    );
}
